<template>
  <div class="content flex flex-1 h-0">
    <div class="sidebar bg-ff overflow-y" v-if="step.length > 0">
      <el-scrollbar style="height: 100%;">
        <div class="ptb-12 plr-20 border-b-dashed-e2 text-left cursor" v-for="(item, index) in step" :key="index" :class="{'stepActive' : stepIndex === index}" @click="handleStep(index)">
          <div :class="stepIndex === index ? 'font-12-ff' : 'font-12-b9b9b9'">计划时间：</div>
          <div :class="stepIndex === index ? 'font-12-ff' : 'font-12-b9b9b9'">2019.07.16 ~ 2019.07.17</div>
          <div class="mt-10" :class="stepIndex === index ? 'font-14-ff' : 'font-14-30313a'">{{item.name}}</div>
          <div class="flex flex-wrap">
            <div class="btn-16-bg-82b925-r mt-10 mr-10">已验收</div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div class="section bg-ff flex-1 flex-column" v-if="step.length > 0">
      <div class="title flex w-100 align-center">
        <div class="decoration-line mr-5"></div>
        <div class="font-16-f5971d font-bold">{{step[stepIndex].name}}</div>
      </div>
      <div class="flex-1 h-0 overflow-y">
        <el-scrollbar style="height: 100%;">
          <div class="flex flex-wrap pt-20 pb-10 plr-10 list">
            <div class="picItem flex-column" v-if="pic.length > 0" v-for="(item, index) in pic" :key="index">
              <div class="flex" :style="{height: picHeight}">
                <el-image :src="item.path" fit="cover"></el-image>
              </div>
              <div class="bg-f3f4f7 p-10 text-left relative">
                <div class="font-12-30313a mb-2">{{item.name}}</div>
                <div class="font-12-b9b9b9">上传： {{item.uploaderName}} {{Utils.formatDate2(item.createTime)}}</div>
                <div class="font-12-b9b9b9">审核： {{item.auditorName}} {{Utils.formatDate2(item.auditTime)}}</div>
                <div class="absolute w-100 flex justify-center" style="top: -20px; left: 0">
                  <div class="tip flex align-center justify-center text-overflow">
                    <img class="mr-5" src="/static/images/customer/dingwei.png" alt="">
                    <div>{{item.address || '暂无详细地址信息'}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EffectPic',
  components: {},
  props: {
    customerId: String,
    picHeight: String
  },
  data () {
    return {
      pic: [],
      step: [],
      stepIndex: 0
    }
  },
  created () {},
  mounted () {
    this.getStep()
  },
  methods: {
    handleStep (index) {
      this.stepIndex = index
      this.getPic()
    },
    getStep () {
      this.axios.post(`${this.$store.state.API_URL_9010}/progressDetail/list`, {
        customerId: this.customerId
      }).then(res => {
        if (res.data.success) {
          this.step = res.data.data.list
          if (this.step.length > 0) {
            this.getPic()
          }
        }
      })
    },
    getPic () {
      this.axios.post(`${this.$store.state.API_URL_9010}/progressPhoto/list`, {
        detailId: this.step[this.stepIndex].id
      }).then(res => {
        if (res.data.success) {
          this.pic = res.data.data
          this.$parent.$parent.$parent.picHeight = (document.querySelector('.list').clientWidth - 70) / 5 + 'px'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .overflow-y{
    overflow-y: auto;
  }
  .section{
    border-radius: 4px;
    margin: 10px 20px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .section .title{
    height: 36px;
    padding-left: 20px;
    border-bottom: 1px solid #e2e2e2;
  }
  .picItem {
    width: calc((100% - 50px) / 5);
    margin: 0 5px 10px;
  }
  .content /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .sidebar{
    width: 200px;
    height: 100%;
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    background: #fff;
  }
  .tip{
    width: 186px;
    height: 20px;
    background: rgba(0,0,0,0.1);
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
  }
  .stepActive{
    background: #f5971d;
  }
  .text-overflow{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/pages/successfulCases/components/ConstructionManagement.vue